import NumberFlow from "@number-flow/react";

/**
 * Tabular-aligned animated number with locale formatting.
 * Wraps @number-flow/react with our brand defaults so callers don't
 * have to repeat configuration.
 */
export function AnimatedNumber({
  value,
  prefix,
  suffix,
  decimals = 0,
  className,
}: {
  value: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  className?: string;
}) {
  return (
    <span className={className}>
      <NumberFlow
        value={Number.isFinite(value) ? value : 0}
        format={{
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        }}
        prefix={prefix}
        suffix={suffix}
        transformTiming={{ duration: 700, easing: "cubic-bezier(0.22,1,0.36,1)" }}
        spinTiming={{ duration: 800, easing: "cubic-bezier(0.22,1,0.36,1)" }}
      />
    </span>
  );
}
